module.exports = __webpack_public_path__ + "static/media/signage-industrial-img19.fa13c9be.jpg";